import { useState, useEffect } from "react";
import { Employee } from "@/types/employee";
import EvaluationMatrix from "@/components/EvaluationMatrix";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

const EvaluationMatrixPage = () => {
  const { user, userRole, profile, loading: authLoading } = useAuth();
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadEmployees = async () => {
      // Warten, bis der Auth-Context (inkl. Profil) initial geladen ist.
      if (authLoading) return;

      if (!user) {
        setLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from('employees')
        .select('*')
        .is('archived_at', null)
        .eq('exclude_from_evaluation', false)
        .order('name');

      if (error) {
        console.error('Error loading employees:', error);
      }

      // Aktuell angemeldeten Benutzer ausblenden (falls employee_id vorhanden)
      const currentEmployeeId = profile?.employee_id;
      const rawData = (data || []).filter((emp: any) => 
        currentEmployeeId ? emp.id !== currentEmployeeId : true
      );

      setEmployees(rawData.map((emp: any) => ({
        id: emp.id,
        name: emp.name,
        position: emp.employee_position || emp.position,
        employeeNumber: emp.employee_number || '',
        startDate: emp.created_at?.split('T')[0] || ''
      })));

      setLoading(false);
    };

    loadEmployees();
  }, [user, userRole, profile?.employee_id, authLoading]);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8 flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-2 sm:px-4 py-4 sm:py-8">
      <div className="mb-4 sm:mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-foreground">Bewertungsmatrix</h1>
        <p className="text-sm sm:text-base text-muted-foreground mt-2">
          Bewerten Sie alle Mitarbeiter gleichzeitig in einer übersichtlichen Matrix
        </p>
      </div>
      
      <EvaluationMatrix employees={employees} />
    </div>
  );
};

export default EvaluationMatrixPage;
